import React, { createContext, useContext, useMemo } from "react";
import type { PermissionsResponse } from "@/types/permissions";
import { buildPermissionIndex, makePermissionAPI } from "@/utils/permissions";

type PermissionAPI = ReturnType<typeof makePermissionAPI>;

const PermissionContext = createContext<PermissionAPI | null>(null);

type PermissionProviderProps = {
  permissionsResponse: PermissionsResponse | null | undefined;
  children: React.ReactNode;
};

const PermissionProvider: React.FC<PermissionProviderProps> = ({
  permissionsResponse,
  children,
}) => {
  const api = useMemo(() => {
    if (!permissionsResponse) {
      return makePermissionAPI({ byKey: {}, groups: {} });
    }
    const index = buildPermissionIndex(permissionsResponse);
    return makePermissionAPI(index);
  }, [permissionsResponse]);

  return (
    <PermissionContext.Provider value={api}>
      {children}
    </PermissionContext.Provider>
  );
};

export const useCan = () => {
  const ctx = useContext(PermissionContext);
  if (!ctx) {
    return makePermissionAPI({ byKey: {}, groups: {} });
  }
  return ctx;
};

export default PermissionProvider;
